import { onMounted, onUnmounted } from 'vue';
import confetti from 'canvas-confetti';

export const useMoneyClicks = () => {
  onMounted(() => {
    document.addEventListener('click', shoot);
  });
  onUnmounted(() => {
    document.removeEventListener('click', shoot);
  });

  const money = confetti.shapeFromText({ text: '💵', scalar: 5 });

  function shoot(e: MouseEvent) {
    confetti({
      origin: {
        x: e.x / window.innerWidth,
        y: e.y / window.innerHeight,
      },
      gravity: 1,
      decay: 0.94,
      startVelocity: 20,
      particleCount: 1,
      scalar: 5,
      shapes: [money],
    });
  }
};
